import { ICopyable } from '../core/copyable.interface';
import { IContact } from './interface/contact.interface';

export class Contact implements ICopyable<Contact> {
    id: string = null;
    email: string = null;
    mobileNumber: string = null;
    firstName: string = null;
    lastName: string = null;
    organizationId: string = null;
    companyName: string = null;

    get editableId(): string | number {
        return this['id'];
    }

    public createCopy(): Contact {
        const instance = new Contact();
        instance.id = this.id;
        instance.email = this.email;
        instance.mobileNumber = this.mobileNumber;
        instance.firstName = this.firstName;
        instance.lastName = this.lastName;
        instance.organizationId = this.organizationId;
        instance.companyName = this.companyName;

        return instance;
    }

    public static createFormCopy(contact: IContact): Contact {
        const instance = new Contact();
        instance.id = contact.id;
        instance.email = contact.email;
        instance.mobileNumber = contact.mobileNumber;
        instance.firstName = contact.firstName;
        instance.lastName = contact.lastName;
        instance.organizationId = contact.organizationId;
        instance.companyName = contact.companyName;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.email = other.email;
        this.mobileNumber = other.mobileNumber;
        this.firstName = other.firstName;
        this.lastName = other.lastName;
        this.organizationId = other.organizationId;
        this.companyName = other.companyName;
    }

    public GetDisplayName() {
        return `${this.email}`;
    }
}
